import './App.css';
import MyErrorBoundary from './components/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <main>
      <MyErrorBoundary />
    </main>
  );
}

export default App;
